import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import Hakkinda from './../../../components/List/HakkindaList';

const AdminHakkinda = () => {
    return (
        <div className="dashboard">
            <Sidebar />
            <div className="dashboardContainer">
                <Navbar />
                <div className="listContainer">
                    <Hakkinda title={"Hakkında"} />
                </div>
            </div>
        </div>
    )
}

export default AdminHakkinda
